const isProd = process.env.NODE_ENV === "production";

function createLogger(prefix, method) {
  if (isProd) return () => {};

  return (...args) => {
    console[method](`[${prefix}]`, ...args);

    if (method === "error") {
      const stackLine = new Error().stack?.split("\n")[2]?.trim();
      if (stackLine) console.error(`  at ${stackLine}`);
    }
  };
}

export const debugLog = createLogger("LOG", "log");
export const debugWarn = createLogger("WARN", "warn");
export const debugError = createLogger("ERROR", "error");
